import { Modal } from '../../../../lib/ui/modal/components/modal/Modal'
import { BpButton } from '../../buttons/bp-button/BpButton'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

import styles from './SetUpTracking.module.scss'

export interface SetUpTrackingProps {
  project: number

  show?: boolean

  onHide?: () => void
}

export const SetUpTracking = (props: SetUpTrackingProps) => {
  const { project, show = false, onHide } = props

  const { t } = useTranslation()
  const [isShow, setIsShow] = useState(show)
  const navigate = useNavigate()

  const handleNavigate = () => {
    setIsShow(false)
    onHide?.()
    navigate(`/projects/${project}/affiliate-tracking`)
  }

  const handleSkip = () => {
    setIsShow(false)
    onHide?.()
  }

  useEffect(() => {
    setIsShow(show)
  }, [show])

  return (
    <Modal open={isShow}>
      <div className={clsx(styles.wrapper)}>
        <div className={clsx(styles.header)}>
          <div className={clsx(styles.image)}>
            <svg
              fill='none'
              height='140'
              viewBox='0 0 138 140'
              width='138'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                clipRule='evenodd'
                d='M16.061 35.308C17.3548 23.2025 32.0901 32.1519 43.487 26.9153C42.8073 31.1227 42.1504 34.9767 41.6461 39.0769C49.5119 40.7334 58.2072 42.2724 68.9347 42.1022V42.1002H69.066V42.1022C79.7935 42.2717 88.4888 40.7327 96.3546 39.0769C95.8503 34.9767 95.1941 31.122 94.5137 26.9153C105.911 32.1512 120.646 23.2018 121.94 35.308C122.745 42.8416 113.923 48.1571 101.091 51.2461C110.94 55.3698 119.315 63.0549 122.963 68.7853C118.35 81.8578 98.8883 91.7956 86.7806 95.7727C95.6527 93.5283 104.74 89.8417 111.412 85.6481C121.735 89.96 128.598 95.6869 132 102.83C101.881 153.181 36.0751 151.593 6 102.83C9.40201 95.6876 16.2654 89.9606 26.5882 85.6481C33.2596 89.8417 42.3473 93.5283 51.2194 95.7727C39.1117 91.7956 19.6495 81.8571 15.0366 68.7853C18.6852 63.0542 27.06 55.3698 36.9089 51.2461C24.0773 48.1571 15.2555 42.8416 16.061 35.308ZM66.6835 59.7535C63.4839 61.9247 66.0238 66.848 56.407 66.9524C48.7748 67.0354 44.6579 62.9608 44.0555 54.7293C59.2792 57.6419 78.4002 57.7609 93.9479 55.0903C93.2523 63.0798 89.1451 67.0333 81.6247 66.9517C72.0079 66.8473 74.5479 61.924 71.3482 59.7528C69.7098 58.64 68.322 58.6406 66.6835 59.7535ZM97.5938 52.0131C89.0028 53.7284 78.9902 54.5418 69.0003 54.4492C59.0112 54.5418 48.9986 53.7284 40.4069 52.0131C43.9415 79.8188 56.8167 89.6494 69.0003 94.1418C81.184 89.6494 94.0585 79.8188 97.5938 52.0131ZM93.7262 32.5718C92.7792 27.0578 91.5676 19.9925 91.4246 19.2385C90.4941 14.3187 89.563 9.39338 88.6346 4.4708C86.4601 -5.39996 73.8813 4.15609 69.0003 4.14641C64.1194 4.15609 51.5399 -5.40065 49.3661 4.4708C48.4377 9.39338 47.5066 14.3187 46.5761 19.2385C46.4338 19.9925 45.2215 27.0578 44.2752 32.5718C50.9963 34.6011 61.8309 35.4802 68.9126 35.4408H69.0895C76.1705 35.4802 87.0051 34.6018 93.7262 32.5718Z'
                fill='black'
                fillRule='evenodd'
              />
              <path
                d='M138 116C138 127.598 128.598 137 117 137C105.402 137 96 127.598 96 116C96 104.402 105.402 95 117 95C128.598 95 138 104.402 138 116Z'
                fill='white'
              />
              <path
                d='M124 129.667V126.333M127.333 123H130.667M109.083 115.155L106.726 117.512C104.123 120.116 104.124 124.336 106.728 126.94C109.331 129.543 113.551 129.544 116.155 126.94L118.513 124.583M107.333 109.667H104M110.667 103V106.333M116.155 108.084L118.512 105.727C121.116 103.124 125.336 103.123 127.94 105.726C130.543 108.33 130.542 112.551 127.939 115.155L125.582 117.512'
                stroke='#00326D'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='3'
              />
            </svg>
          </div>
        </div>
        <div className={clsx(styles.content)}>
          <p className={clsx(styles.title)}>{t('pages.projects.setUpTracking')}</p>
          <p className={clsx(styles.description)}>{t('pages.projects.setUpTrackingDescription')}</p>
          <div className={clsx(styles.buttons)}>
            <BpButton className={'uppercase'} onClick={handleNavigate}>
              {t('pages.projects.buttons.setUpTracking')}
            </BpButton>
            <BpButton className={'uppercase'} theme={'outline'} onClick={handleSkip}>
              {t('pages.projects.buttons.skip')}
            </BpButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}
